import * as ACTION_TYPES from './Types';

const initialState = {
  grades: {},
  message: '',
  error: null,
}

export const gradeReducer = (state = initialState, action) => {
  switch (action.type) {

    case ACTION_TYPES.GETGRADE_SUCCESS:
      return {
        ...state,
        grades: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.GETGRADE_ERROR:
      return {
        ...state,
        message: action.payload.message,
      }
    case ACTION_TYPES.ADDGRADE_SUCCESS:
    case ACTION_TYPES.UPDATEGRADE_SUCCESS:
    case ACTION_TYPES.CHANGEACTION_SUCCESS:
      return {
        ...state,
        categories: action.payload.data,
        message: action.payload.message,
      }

    case ACTION_TYPES.ADDGRADE_ERROR:
    case ACTION_TYPES.UPDATEGRADE_ERROR:
    case ACTION_TYPES.CHANGEACTION_ERROR:

      return {
        ...state,
        message: action.payload.message,
      }

    default:
      return state;
  }
}
